/**
 * format.ts — utilidades de formato compartidas.
 */

/** "45s", "2m 15s", "2m" (sin segundos si son 0) */
export function formatDuration(seconds: number | null | undefined): string | null {
  if (seconds == null) return null
  if (seconds < 60) return `${seconds}s`
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return s > 0 ? `${m}m ${s}s` : `${m}m`
}

/** "ahora", "hace 5m", "hace 2h", o fecha corta si pasó más de un día */
export function timeAgo(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diffMs / 60000)
  if (mins < 1) return 'ahora'
  if (mins < 60) return `hace ${mins}m`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `hace ${hrs}h`
  const days = Math.floor(hrs / 24)
  if (days < 30) return `hace ${days}d`
  return new Date(iso).toLocaleDateString('es-DO', { day: '2-digit', month: 'short' })
}

/**
 * Número de cliente sin ceros a la izquierda y SIN prefijo #.
 * Ejemplo: 1 → "1", 32341 → "32341" (nunca "00001" ni "#1").
 * El # visual se pone una sola vez en la UI si se necesita.
 */
export function formatClientNum(n: number | null | undefined): string {
  return String(Number(n ?? 0))
}

/** Copia texto al portapapeles; devuelve true si ok. */
export async function copyText(text: string): Promise<boolean> {
  const t = (text ?? '').trim()
  if (!t) return false
  try {
    await navigator.clipboard.writeText(t)
    return true
  } catch {
    try {
      const ta = document.createElement('textarea')
      ta.value = t
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(ta)
      return ok
    } catch {
      return false
    }
  }
}
